import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import PropTypes from 'prop-types'
import './DonutChartT1.scss'
import sanitizeHtml from 'sanitize-html'
export class DonutChartT1 extends React.Component {

  render() {
    const { chartData, groupByBedsCount, donutChartThemeColors, isStudentHousing } = JSON.parse(sanitizeHtml(JSON.stringify(this.props)))
    const data = {
      labels: chartData && Object.keys(chartData).sort(),
      datasets: [
        {
          data: chartData && Object.keys(chartData).sort()
            .map(label => chartData[`${label}`]),
          backgroundColor: chartData && Object.keys(chartData).sort()
            .map(label => donutChartThemeColors[label.trim().replace(/ /g, '')
              .toLowerCase()
              .replace('/', ' / ')
              .replace('bedroom', ' Bedroom')
              .replace('bath', ' Bath')]),
          hoverBackgroundColor: chartData && Object.keys(chartData).sort()
            .map(label => donutChartThemeColors[label.trim().replace(/ /g, '')
              .toLowerCase()
              .replace('/', ' / ')
              .replace('bedroom', ' Bedroom')
              .replace('bath', ' Bath')])
        }
      ]
    }

    return (
      <div data-testid="donut-chart" className="donut-container">
        <div className="chart">
          <div className="donutchart">
            <Doughnut data={data}
              options={{
                padding: '0px',
                responsive: true,
                maintainAspectRatio: false,
                defaultFontSize: '14px',
                tooltips: {
                  enabled: false
                },
                legend: {
                  display: false
                },
                elements: {
                  arc: {
                    borderWidth: 0
                  }
                },
                cutoutPercentage: 65
              }}
            />
          </div>
          <div className="chartlabel">
            {chartData && Object.keys(chartData).sort()
              .map((unitType, index) => (
                <div key={index} className="donutlabel">
                  <div style={{
                    'backgroundColor': donutChartThemeColors[unitType.trim().replace(/ /g, '')
                      .toLowerCase()
                      .replace('/', ' / ')
                      .replace('bedroom', ' Bedroom')
                      .replace('bath', ' Bath')]
                  }} className="labelcolor"></div>
                  <div>
                    {isStudentHousing ?
                      <>
                        {`${unitType.includes('0 Bedroom') ? 'Studio' : unitType.replace('Bedroom', 'Bed')} - ${chartData[unitType]}% (${groupByBedsCount[unitType]} Beds)`}
                      </>
                      : <>
                        {`${unitType.includes('0 Bedroom') ? 'Studio' : unitType.replace('Bedroom', 'Bed')} - ${chartData[unitType]}%`}
                      </>
                    }
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    )
  }
}

DonutChartT1.propTypes = {
  chartData: PropTypes.shape({
    '1 Bedroom / 1 Bath': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    '2 Bedroom / 1 Bath': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    '2 Bedroom / 2 Bath': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    '3 Bedroom / 3 Bath': PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  groupByBedsCount: PropTypes.shape({
    '1 Bedroom / 1 Bath': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    '2 Bedroom / 1 Bath': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    '2 Bedroom / 2 Bath': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    '3 Bedroom / 3 Bath': PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  isStudentHousing: PropTypes.bool,
  donutChartThemeColors: PropTypes.object
}
export default DonutChartT1
